import { WorkTrayColumn } from 'runtime/data/worktraycolumn';

export class WorkTrayView {
    id: string;
    name: string;
    includeAvailable: boolean;
    includeClaimedByCurrentUser: boolean;
    includeClaimedByOtherUser: boolean;
    displayActionMenu: boolean;
    displayHistory: boolean;
    displayHistoryAvailable: boolean;
    columns: WorkTrayColumn[];
    viewDataPreference: string;
    selectAllPreference: string;
}